<template>
    <div class="p-register-card">
        <div class="register-card">
            <p class="sub-title" v-html="boxTitle" />
            <p-register-card-form></p-register-card-form>
        </div>
        <slot ref="slot"></slot>
    </div>
</template>

<script>
    import PRegisterCardForm from '@theme-views/public/partials/PRegisterCard/Form'

    export default {
        name: 'p-register-card',
        components: {PRegisterCardForm},
        data() {
            return {
                content: window.APP_CONFIG.LANDING_PAGE_CONTENT,
            }
        },
        computed: {
            boxTitle() {
                return this.content.registration_box_title ? this.content.registration_box_title : this.$t('Join Us')
            }
        }
    }
</script>

<style lang="scss">
.p-register-card {
    .p-register-card-form {
        .form-con {
            padding: 40px;
            margin-top: 20px;
        }
    }
}
</style>